const CARD = "POS";
const TRANSFERENCE = "TRA";
const SPEI = "SPE";
const CASH = "OXX";
const TICKET = "BOL";
const MOBIL = "MOB";

const getTransactionTypeIntId = (value) =>
  ({
    [CARD]: "resume.transactionDetails.type.card",
    [TRANSFERENCE]: "resume.transactionDetails.type.transference",
    [SPEI]: "resume.transactionDetails.type.spei",
    [CASH]: "resume.transactionDetails.type.oxxo",
    [TICKET]: "resume.transactionDetails.type.ticket",
    [MOBIL]: "resume.transactionDetails.type.mobil",
  }?.[value] || "");

export {
  getTransactionTypeIntId,
  CARD,
  TRANSFERENCE,
  SPEI,
  CASH,
  TICKET,
  MOBIL,
};
